<template>
    <div>
        <carousel id="marketplace_slider"
                  v-if="isLoaded"
                  :responsive="configCarousel.responsive"
                  :lazyLoad="true"
                  :loop="true"
                  :autoplay="false"
                  :nav="false"
                  :dots="false">
            <div v-for="(campaign,k) in list"
            :key="k" class="marketplace-slider-item" @click="clickCampaign(campaign)">
                <div class="img-marketplace">
                    <img :src="campaign.fullImageUrl" class="img-fluid"/>
                </div>
                <div class="content-marketplace">
                    <div class="text-name">{{campaign.name}}</div>
                    <div v-html="getPointText(campaign.pointPerUnit, campaign.pointType)"></div>
                    <!-- <div class="text-point">Use <span class="theme-txt">1,000</span> Point</div> -->
                    <!-- <div class="text-point theme-txt">{{getPointText(campaign.pointPerUnit)}}</div> -->
                </div>
            </div>
        </carousel>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import Util from "@/helper/Utility.js";

import Carousel from 'vue-owl-carousel'; // https://github.com/s950329/vue-owl-carousel

export default {
    name: "MarketPlaceSlider",
    mixins: [LocaleMixin],
    components: {
        Carousel,
    },
    props: {
        list: Array,
        isLoaded: Boolean
    },
    data: function() {
        return {
            configCarousel: {
                responsive: {
                    0:{
                        items: this.list.length > 1 ? 1.1 : 1,
                    }
                },
            },
            trackingService: new TrackingService(this),
        };
    },
    created: function() {
        this.trackingService.event('privilagelist_page', 'view_online_catalog', null, null);
    },
    methods: {
        clickCampaign: function (campaign) {
            this.trackingService.screenName('campaignslist');
            this.trackingService.event('campaigndetail_page', 'click_to_campaigndetail', null, null);

            var path = "/product/" + campaign.id;
            this.$router.push(path);
        },
        // getPointText: function (point) {
        //     var text_point = this.locale === 1033 && point > 1
        //                 ? this.lbl.campaign.point + 's'
        //                 : this.lbl.campaign.point;

        //     return `<div class="text-point">${this.lbl.campaign.use_point} <span class="theme-txt">${Util.formatNum(point)}</span> ${text_point}</div>`;
        //     // return this.lbl.campaign.use_point + ' '  + Util.formatNum(point) + ' ' + text_point;
        // }

        getPointText: function (point, pointType) {
            var pointTypeTxt = pointType && pointType != 'use'
                            ? this.lbl.campaign.get_point
                            : this.lbl.campaign.use_point;

            var pointUnit = this.locale === 1033 && point > 1
                        ? this.lbl.campaign.point + 's'
                        : this.lbl.campaign.point;

            return `<div class="text-point">${pointTypeTxt} <span class="points">${Util.formatNum(point)}</span> ${pointUnit}</div>`;
        }
    },
}
</script>
<style lang="scss">
@import "@/style/base/common.scss";
@import "@/style/base/base.scss";

#marketplace_slider {
    .owl-item{
        padding: 4px 20px 0 4px;
    }
}

.marketplace-slider-item{
    @include boxShadow(#ffffff, 0.5px, 229, 229, 229);
    border: none;
    border-radius: 8px;
    line-height: 1;

    .img-marketplace{
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        overflow: hidden;
        border-radius: 8px 8px 0 0;

        img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }

        &:before {
            position: relative;
            content: "";
            display: block;
            padding-top: 66.67%;
        }
    }
    .content-marketplace {
        padding: 8px;

        .text-name{
            @extend %ellipsis-2;
            font-size: 1.5rem;
            margin-bottom: 8px;
            color: $a-gray-333333;
            height: 50px;
        }
        .text-point{
            font-size: 1.6rem;
            color: $a-gray-575757;

            .points {
                color: $green-00987F;
                font-weight: 600;
            }
        }
    }
}
</style>
